"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewPanel = void 0;
const react_1 = __importStar(require("react"));
const react_responsive_1 = require("react-responsive");
const Icon_1 = require("../Icons/Icon");
const PreviewModal_1 = __importDefault(require("./PreviewModal"));
const PreviewPanel = function ({ resource, previewModalOverlayProps, modalState, onSelect, onClose, ResourceComponent, selectionCallback, }) {
    // Watch the media size to see if we are on mobile size
    const isMobile = (0, react_responsive_1.useMediaQuery)({ query: '(max-width: 640px)' });
    // If we are on mobile and the selected resource changes show the preview panel modal.
    (0, react_1.useEffect)(() => {
        if (!modalState.isOpen) {
            modalState.setOpen(Boolean(resource && isMobile));
        }
    }, [resource, isMobile]);
    const previewPanel = resource && (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "flex flex-col grow" }, ResourceComponent && react_1.default.createElement(ResourceComponent, { resource: resource, selectionCallback: selectionCallback })),
        react_1.default.createElement("div", { className: "flex justify-end border-t border-gray-300" },
            react_1.default.createElement("button", { type: "button", onClick: () => onSelect(resource), className: "rounded text-sm text-white bg-blue-300 py-2 px-2.5 m-5 font-bold" }, "Select"))));
    return (react_1.default.createElement("div", { className: "squiz-gb-scope h-full" },
        !isMobile && react_1.default.createElement("h3", { className: "sr-only" }, "Resource Details"),
        resource === null && (react_1.default.createElement("div", { className: "max-sm:hidden flex flex-col h-full" },
            react_1.default.createElement("div", { className: "flex flex-col grow items-center mt-20 mx-20" },
                react_1.default.createElement(Icon_1.Icon, { icon: 'resource-select', "aria-hidden": true }),
                react_1.default.createElement("div", { className: "text-sm text-gray-600 text-center mt-4" }, "Make a selection to see more info here.")),
            react_1.default.createElement("div", { className: "flex justify-end border-t border-gray-300" },
                react_1.default.createElement("button", { disabled: true, type: "button", className: "rounded text-sm text-white bg-blue-300/[.6] py-2 px-2.5 m-5" }, "Select")))),
        resource && isMobile && modalState.isOpen && (react_1.default.createElement(PreviewModal_1.default, { state: modalState, overlayProps: previewModalOverlayProps, onClose: onClose }, previewPanel)),
        resource && !isMobile && react_1.default.createElement("div", { className: "flex flex-col h-full" }, previewPanel)));
};
exports.PreviewPanel = PreviewPanel;
